<template>
  <div class="exclusivePreferential-page flex">
    <el-form ref="form" class="my-form" :model="form" :rules="rules" label-width="150px" size="small">
      <div class="white-container">
        <el-form-item label="权益主标题" prop="titles">
          <div v-if="isEdit" class="mainTitleWrap flex">
            <template v-for="(mainTitle,titleN) in form.titles">
              <el-input :key="titleN+'mainTitle'" v-model="form.titles[titleN]" class="common-input" :placeholder="titleN === 0 ? '请输入第一行主标题文案' : '请输入第二行主标题文案' " />
            </template>
          </div>
          <div v-else class="lh-20" style="padding-top: 5px;">
            <div v-for="(mainTitle,titleN) in form.titles" :key="titleN+'mainTitle'">{{ mainTitle }}</div>
          </div>
        </el-form-item>
        <el-form-item label="副标题" prop="subtitles">
          <div v-if="isEdit" class="subTitleWrap flex">
            <template v-for="(subTitle,titleN) in form.subtitles">
              <el-input :key="titleN+'subTitle'" v-model="form.subtitles[titleN]" class="common-input" :placeholder="titleN === 0 ? '请输入第一行副标题文案' : '请输入第二行副标题文案'" />
            </template>
          </div>
          <div v-else class="lh-20" style="padding-top: 5px;">
            <div v-for="(subTitle,titleN) in form.subtitles" :key="titleN+'subTitle'">{{ subTitle }}</div>
          </div>
        </el-form-item>

        <el-form-item label="卡片背景图" prop="imageUrl" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage v-if="isEdit" :url="form.imageUrl" size-tips="960px*660px" :save-path="savePath" @upload="uploader" @triggerReg="handleCheckReg" />
            <img v-else class="read-img" :src="form.imageUrl" alt="">
          </div>
        </el-form-item>
        <el-form-item label="报名卡片下架时间" prop="offlineTime" style="width: 279px">
          <el-date-picker v-model="form.offlineTime" type="datetime" placeholder="报名结束时间" prefix-icon="el-icon-date" class="custom-date" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" :disabled="!isEdit" />
        </el-form-item>
        <el-form-item label="UAstar活动链接地址" prop="linked">
          <template v-if="isEdit">
            <el-input v-model="form.linked" class="common-input w-360" placeholder="输入活动页面链接地址" />
          </template>
          <div v-else>{{ form.linked }}</div>
        </el-form-item>
      </div>
      <div class="white-container mt-30">
        <div>
          <div>活动落地页配置</div>
          <el-form-item label="落地页长图" prop="landingPageImageUrl" class="image-config mt-30">
            <div class="flex uploadImg-cont">
              <UploadImage v-if="isEdit" :url="form.landingPageImageUrl" breadth="1125px" :save-path="savePath" @upload="headUpLong" @triggerReg="handleCheckLongPic" />
              <img v-else class="read-img" :src="form.landingPageImageUrl" alt="">
            </div>
          </el-form-item>
        </div>

        <el-form-item class="opetare-box flex">
          <div class="flex btns">
            <template v-if="isEdit">
              <el-button type="info" @click="cancel">取消</el-button>
              <el-button type="primary" @click="submit">保存</el-button>
            </template>
            <el-button v-else type="primary" @click="cancel">返回</el-button>

          </div>
        </el-form-item>
      </div>

    </el-form>

  </div>
</template>

<script>

import { BrandEventInvitation } from '@/model/Benefits';
import UploadImage from './UploadImage';
export default {
  components: { UploadImage },
  data() {
    return {
      form: new BrandEventInvitation(),
      rules: {
        titles: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                callback(new Error('请输入权益主标题'));
              }
              const bool = value.some(item => item !== '');
              if (!bool) {
                callback(new Error('请输入权益主标题'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
        subtitles: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                callback(new Error('请输入副标题'));
              }
              const bool = value.some(item => item !== '');
              if (!bool) {
                callback(new Error('请输入副标题'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
        imageUrl: {
          required: true, validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(`请上传卡片背景图`));
            }
            callback();
          }, trigger: ['change'],
        },
        linked: { required: true, message: "请输入活动页面链接地址", trigger: ["blur", "change"] },
        landingPageImageUrl: {
          required: true, validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(`请上传落地页长图`));
            }
            callback();
          }, trigger: ['change'],
        },
      },
      isEdit: true,
      savePath: 'member/BrandEventInvitation/',
    };
  },
  created() {
    const { query } = this.$route;
    if (query.id) {
      this.id = +query.id;
      this.fetchData();
    }
    if (query.readOnly) {
      this.isEdit = query.readOnly !== '1';
    }
  },
  methods: {
    fetchData() {
      const obj = {
        type: 6,
        brandActivity: {},
        id: this.id,
      };
      this.$Api.benefits.query(obj).then(res => {
        if (res?.brandActivity?.length) {
          const data = res.brandActivity.find(item => item.id === this.id);
          if (!data) return;
          this.form = new BrandEventInvitation(data);
        }
      });
    },
    uploader(file) {
      this.form.imageUrl = file;
    },
    headUpLong(file) {
      this.form.landingPageImageUrl = file;
      console.log(file, 666);
    },
    handleCheckReg() {
      this.$refs.form.validateField("imageUrl");
    },

    handleCheckLongPic() {
      this.$refs.form.validateField("landingPageImageUrl");
    },

    cancel() {
      this.$router.push({ path: '/member/brandEventInvitation/index' });
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const str = this.form.id ? '编辑成功' : '新增成功';
          const api = this.form.id ? this.$Api.benefits.update : this.$Api.benefits.add;
          const obj = { type: 6, brandActivity: this.form };
          api(obj).then(res => {
            this.$message.success(str);
            this.cancel();
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.exclusivePreferential-page {
  position: relative;

  min-height: calc(100vh - 178px);
  .mt-30 {
    margin-top: 30px;
  }
  .w-360 {
    width: 360px !important;
  }
  .lh-20 {
    line-height: 20px;
  }
  :deep(.custom-date) {
    width: 172px !important;
  }
  :deep(.el-input.is-disabled) {
    .el-input__icon {
      cursor: unset;
    }
    .el-input__inner {
      cursor: unset;

      color: #494949;
      border-color: #fff;
      background: #fff;
    }
  }
  :deep(.common-input) {
    width: 360px;
    height: 32px !important;
    margin-right: 30px;

    background: #f7f7f7;

    line-height: 32px !important;
    input {
      height: 32px !important;

      line-height: 32px !important;
    }
    :deep(.el-input__inner) {
      &::placeholder {
        color: #bbbbbb;
      }
    }
    &.underline {
      .el-input__inner {
        text-decoration: underline;
      }
    }
    .el-input__inner {
      color: #494949;
    }
  }
  .my-form {
    display: flex;
    flex: 1;
    flex-direction: column;
    .read-img {
      width: 210px;
      height: 150px;

      border: 1px dashed #e3e3e5;
      border-radius: 16px;
    }
    .add-conpon-title {
      color: #000;

      font-size: 14px;
      font-weight: 400;
      .level-box {
        width: 65px;
        height: 34px;
        margin-right: 10px;

        line-height: 34px;
      }
      .label-box {
        width: 338px;
        height: 34px;

        text-align: center;

        border-bottom: 1px solid #f8f8f9;
        background: #e3e3e5;
      }
    }
    .conpon-wrap {
      color: #000;

      font-size: 14px;
      font-weight: 400;
      & + .conpon-wrap {
        margin-top: 5px;
      }

      &:nth-of-type(2) .level-box {
        display: flex;
        align-items: center;

        height: 197px;
      }
      .level-box {
        width: 65px;
        height: 34px;
        margin-right: 10px;

        line-height: 34px;
      }
      .content-wrap {
        .content-box {
          flex-direction: column;

          width: 338px;
          height: 197px;

          border: 1px dashed #e3e3e5;
          background: #f7f7f7;
          .conpun-list {
            overflow-y: auto;

            max-height: 153px;
            .conpun-item {
              position: relative;

              height: 41px;
              margin: 10px 10px 0 10px;

              border-top: 4px solid #000;
              background: #fff;
              .close {
                position: absolute;
                top: -7px;
                right: -6px;

                display: block;

                width: 13px;
                height: 13px;

                cursor: pointer;
              }
            }
          }
          .add-wrap {
            display: flex;
            align-items: center;
            flex: 1;
            justify-content: center;

            cursor: pointer;

            color: #bbb;
            .el-icon-plus {
              margin-right: 6px;

              font-size: 12px;
            }
            &:hover {
              color: #000;
            }
          }
          &:first-of-type {
            border-radius: 4px 0px 0px 4px;
          }
          &:last-of-type {
            border-left: none;
            border-radius: 4px 0px 4px 0px;
          }
        }
      }
    }
  }
  .opetare-box {
    justify-content: center;

    margin-top: 30px;
    margin-bottom: 0 !important;
  }
  :deep(.el-dialog__wrapper) {
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    .coupon-wrapper {
      width: 678px;
      margin: unset !important;
      .el-dialog__header {
        box-sizing: border-box !important;
        height: 74px !important;
        padding: 25px 30px !important;

        background: #000000 !important;

        .el-dialog__title {
          color: #ffffff;

          font-size: 16px;
          font-weight: 500;
        }
        .el-dialog__headerbtn {
          top: 25px;
          right: 30px;

          font-size: 24px;
          .el-dialog__close {
            color: #ffffff;
            &:hover {
              color: #dc0019;
            }
          }
        }
      }
      .el-dialog__body {
        padding: 30px;
        .coupon-wrap {
          display: flex;
          .title {
            margin-top: 7px;
            margin-right: 10px;

            white-space: nowrap;

            color: #494949;

            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
          }
          .text {
            width: 618px;
          }
        }
      }
      .btns {
        justify-content: center;

        margin-top: 30px;
        .el-button {
          width: 120px;
          height: 50px;
        }
        .el-button + .el-button {
          margin-left: 30px;
        }
      }
    }
  }
}
</style>
